// @flow
import * as React from 'react';
import { typeof Button, Box, ThemeContext } from 'grommet';
import { memoize } from 'lodash';


type Direction = 'row' | 'column';

type Props = {
    direction: Direction,
    children: Array<Button>,
};


const getTheme = memoize((direction: Direction, originalTheme: Object) => ({
    button: {
        extend: (props: Object) => {
            let style = originalTheme.button && originalTheme.button.extend ? originalTheme.button.extend(props) : '';

            if (direction === 'row') {
                style = `
                    ${style}
                    :not(:first-child) {
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                    }
                    
                    :not(:last-child) {
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                    
                    & + & {
                        border-left: 0;
                    }
                `;
            } else {
                style = `
                    ${style}
                    :not(:first-child) {
                        border-top-left-radius: 0;
                        border-top-right-radius: 0;
                    }
                    
                    :not(:last-child) {
                        border-bottom-left-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                    
                    & + & {
                        border-top: 0;
                    }
                `;
            }

            return style;
        },
    },
}));


const ButtonGroup = (props: Props) => {
    const { direction, children } = props;

    return (
        <ThemeContext.Consumer>
            {(theme: Object) => (
                <ThemeContext.Extend value={getTheme(direction, theme)}>
                    <Box direction={direction}>
                        {children}
                    </Box>
                </ThemeContext.Extend>
            )}
        </ThemeContext.Consumer>
    );
};


ButtonGroup.defaultProps = {
    direction: 'row',
};


export default ButtonGroup;
